import type { OptimizationActionResponseModel } from '@/shared/generated'

import React from 'react'
import { RiCheckboxCircleFill, RiCloseCircleFill } from '@remixicon/react'
import { useTranslation } from 'react-i18next'

import { useOptimizationGroupsQuery } from '@/entities/optimization-group'

import { Spinner } from '@/shared/components/ui/spinner'

export function OptimizationActionsResponseList({
	data,
}: {
	data: OptimizationActionResponseModel[]
}) {
	const { t } = useTranslation()
	const optimizationGroupsQuery = useOptimizationGroupsQuery()
	const optimizationGroupsMap = optimizationGroupsQuery.data?.reduce(
		(acc, item) => {
			acc[item.id] = item.name

			return acc
		},
		{} as Record<string, string>
	)
	const isLoading = optimizationGroupsQuery.isLoading

	return (
		<div className='flex flex-col gap-1.5 p-1.5'>
			{data.map((item) => (
				<div key={item.optimization_id} className='flex items-center gap-1'>
					{item.success ? (
						<div className='flex gap-1 rounded-md bg-muted p-1 font-mono text-xs text-muted-foreground'>
							<RiCheckboxCircleFill className='size-4 shrink-0 text-green-500' />
							<div>
								{isLoading ? (
									<span className='inline-flex items-center gap-1 bg-muted font-medium text-foreground'>
										<Spinner className='size-3' />
										{t('loading')}
									</span>
								) : (
									<span className='font-medium text-foreground'>
										"{optimizationGroupsMap?.[item.optimization_group_id]}"
									</span>
								)}
								{' - '}
								{t('general_success')}
							</div>
						</div>
					) : (
						<div className='flex gap-1 rounded-md bg-muted p-1 font-mono text-xs text-muted-foreground'>
							<RiCloseCircleFill className='size-4 shrink-0 text-red-500' />
							<div>
								{isLoading ? (
									<span className='inline-flex items-center gap-1 bg-muted font-medium text-foreground'>
										<Spinner className='size-3' />
										{t('loading')}
									</span>
								) : (
									<span className='font-medium text-foreground'>
										"{optimizationGroupsMap?.[item.optimization_group_id]}"
									</span>
								)}
								{' - '}
								{item.error}
							</div>
						</div>
					)}
				</div>
			))}
		</div>
	)
}
